module.exports = __webpack_public_path__ + "static/img/thermometre-desktop.8a75524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thermometre-desktop.png
// module id = rpwZ
// module chunks = 1